import { Component, OnInit } from '@angular/core';
import { ChartOptions } from 'chart.js';
import { BehaviorSubject } from 'rxjs';
import { GraphDataResponse, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { minutesToHuman } from '~lmo/pipes/minutes-to-human.pipe';
import { formatDateTimeHuman } from '../../../ui-components/standard-date.pipe';

@Component({
  selector: 'sa-time-to-npt',
  styleUrls: ['./time-to-npt.component.scss'],
  templateUrl: './time-to-npt.component.html',
})
export class TimeToNPTComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public timeframe = 3;
  public loading = false;
  public datasets: GraphDataResponse = this.initializeTimeToNPT();
  public isNoDataSubject$$ = new BehaviorSubject<boolean>(true);

  public chartColors: any[] = [
    {
      backgroundColor: ['rgb(32,118,135, 0.5)'],
      borderColor: ['rgb(32,118,135)'],
    },
  ];

  public options: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: humanETATooltip(),
      },
    },
  };

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      this.resetTimeToNPT();
      this.regionID = regionID;
      this.fetchTimeToNpt();
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.resetTimeToNPT();
        this.fracsID = fracsID;
        this.fetchTimeToNpt();
      }

      if (!fracsID && this.regionID) {
        this.resetTimeToNPT();
        this.fetchTimeToNpt();
      }
    });
  }

  private fetchTimeToNpt(): void {
    this.loading = true;
    this.isNoDataSubject$$ = new BehaviorSubject<boolean>(false);
    const nptTimeframe = this.kpiDashboardService.getLocalStorage('npt_timeframe');
    if (nptTimeframe) {
      this.timeframe = nptTimeframe;
    }
    this.kpiDashboardService.getTimeToNPT$(this.regionID, this.fracsID, this.timeframe).subscribe((data) => {
      if (!data.datasets) {
        this.resetTimeToNPT();
        this.loading = false;
        return;
      }

      this.datasets = data;

      this.datasets.labels.map((label, index) => {
        this.datasets.labels[index] = formatDateTimeHuman(label);
      });

      this.datasets.datasets.forEach((value, index) => {
        const sum = value.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        if (value.data.length !== 0 && sum !== 0) {
          this.isNoDataSubject$$?.next(false);
        } else {
          this.isNoDataSubject$$?.next(true);
        }
      });

      this.loading = false;
    });
  }

  private resetTimeToNPT(): void {
    this.datasets = this.initializeTimeToNPT();
  }

  private initializeTimeToNPT(): GraphDataResponse {
    this.isNoDataSubject$$?.next(true);
    return {
      datasets: [
        {
          data: [0],
          label: '',
        },
      ],
      labels: [''],
    };
  }

  public onTimeframeChange(timeframe: number) {
    this.timeframe = timeframe;
    this.kpiDashboardService.setLocalStorage('npt_timeframe', this.timeframe);
    this.fetchTimeToNpt();
  }
}

function humanETATooltip() {
  return function(tooltipItem: Chart.ChartTooltipItem, data: Chart.ChartData) {
    return minutesToHuman(Number(tooltipItem.yLabel));
  };
}
